import { Injectable } from '@angular/core';
import { DataProtectionNoticeList } from '../models/data-protection-notice.model';
import { Observable } from 'rxjs';
import { DataProtectionNoticeEndpoint } from '../constants/data-protection-notice-endpoint';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';

@Injectable({
  providedIn: 'root',
})
export class DataProtectionNoticeListService {
  constructor(private http: WrapperHttpService) {}

  getDpnList(): Observable<DataProtectionNoticeList[]> {
    const url = `${API_URL}${DataProtectionNoticeEndpoint.Base}`;
    return this.http.withLoading().get<DataProtectionNoticeList[]>(url);
  }
}
